// extracted by mini-css-extract-plugin
export default {"fixed":"EmailUS_fixed__CmrRq","bouton":"EmailUS_bouton__V5q3S","form":"EmailUS_form__n11df","textarea":"EmailUS_textarea__84LIO","retour":"EmailUS_retour__6ReMX"};